'use strict'

import firebase from 'firebase/app'
import 'firebase/storage'

const readFile = async (directory, fileName) => {
  let storage = firebase.storage()
  let storageRef = storage.ref()
  let directoryRef = storageRef.child(directory)
  let fileRef = directoryRef.child(fileName)
  return fileRef.getDownloadURL().then(function (url) {
    return new Promise(function (resolve, reject) {
      let xhr = new XMLHttpRequest()
      xhr.responseType = 'text'
      xhr.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          resolve(xhr.response)
        } else {
          reject({
            status: this.status,
            statusText: xhr.statusText
          })
        }
      }
      xhr.open('GET', url)
      xhr.send()
    })
  })
}

const writeFile = async (directory, fileName, content) => {
  let storage = firebase.storage()
  let storageRef = storage.ref()
  let directoryRef = storageRef.child(directory)
  let fileRef = directoryRef.child(fileName)
  log(content)
  return fileRef.putString(content)
}

const deleteFile = async (directory, fileName) => {
  let storage = firebase.storage()
  let storageRef = storage.ref()
  let directoryRef = storageRef.child(directory)
  let fileRef = directoryRef.child(fileName)
  return fileRef.delete()
}

export default {
  readFile,
  writeFile,
  deleteFile
}
